import CheckoutShipmentItem from 'domains/customer-checkout/molecules/shipment-item'
import CheckoutShipmentMethod from 'domains/customer-checkout/molecules/shipment-method'
import CheckoutShipmentMethodList from 'domains/customer-checkout/molecules/shipment-method-list'
import SectionLine from 'domains/customer-checkout/molecules/section-line'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { Button, Card, Collapse, Row, CustomInput, Alert } from 'reactstrap'
import CheckoutTotalService from 'domains/customer-checkout/services/customer-checkout-total-service'
import SHIPMENT_METHOD from 'domains/customer-checkout/constants/checkout-shipment-method'

const CustomerCheckoutShipment = ({
  shipment,
  handleClickShippingMethod,
  handleClickInsuranceCheckbox,
  selectedShipmentMethod
}) => {

  const [ isShipmentMethodOpen, setIsShipmentMethodOpen ] = useState(false)

  const totalPrice           = CheckoutTotalService.calcItemTotal(shipment)
  const isMandatoryInsurance = totalPrice > 1000000
  const isInsuranceAvailable = selectedShipmentMethod?.insurance_cost > 0
  const isCheckboxDisabled   = !isInsuranceAvailable

  const isGrabShipment     = selectedShipmentMethod?.courier == SHIPMENT_METHOD.GRAB_EXPRESS
  const showInsuranceAlert = !isInsuranceAvailable && !isGrabShipment

  // Close the shipment method list whenever shipment changes
  // - when selecting the shipment method
  useEffect(() => {
    setIsShipmentMethodOpen(false)
  }, [ shipment ])

  const CheckoutShipmentItemList = () => (
    shipment.items.map((item) => (
      <div key={ `checkout-shipment-item-${item.product.id}` }>
        <CheckoutShipmentItem item={ item } />
        <SectionLine />
      </div>
    ))
  )


  const InsuranceLabel = () => (
    <small>
      { 'Shipping Insurance ' }
    </small>
  )

  // only for anter aja shipment method
  const InsuranceCheckbox = () => (
    <>
      {
        isMandatoryInsurance && (
          <Alert color='info' className='small'>{ 'Asuransi Pengiriman wajib untuk order diatas Rp. 1,000,000' }</Alert>
        )
      }
      {
        showInsuranceAlert  && (
          <Alert color='info' className='small'>{ 'Order ini tidak bisa dicover oleh asuransi karena total harga yang rendah.' }</Alert>
        )
      }
      {
        !isGrabShipment && (
          <CustomInput
            id={ 'shipment-insurance' }
            type='checkbox'
            disabled={ isCheckboxDisabled }
            checked={ selectedShipmentMethod?.is_insurance }
            onChange={ handleClickInsuranceCheckbox }
            label={ <InsuranceLabel /> }
          />
        )
      }

    </>
  )

  return (
    <Card className={ 'shadow p-3' }>
      <CheckoutShipmentItemList />

      { /* Shipment Method List Selection */ }
      <div className='d-flex align-items-center justify-content-between'>
        <CheckoutShipmentMethod shipmentMethod={ selectedShipmentMethod } />

        <Button
          outline
          size='sm'
          color='primary'
          onClick={ () => setIsShipmentMethodOpen(!isShipmentMethodOpen) }
        >
          Change Method
        </Button>
      </div>
      <hr/>
      {
        selectedShipmentMethod?.note && (
          <Alert
            color='info'
            className='small mt-3'
          >
            <i className='fa fa-info-circle mr-2'/>
            { selectedShipmentMethod.note }
          </Alert>
        )
      }

      { selectedShipmentMethod && <InsuranceCheckbox /> }

      <Row>
        <Collapse isOpen={ isShipmentMethodOpen } style={{ width: '100%' }}>
          <CheckoutShipmentMethodList
            shipmentMethods={ shipment.shipment_methods }
            handleClickShippingMethod={ handleClickShippingMethod }
          />
        </Collapse>
      </Row>

    </Card>
  )
}

CustomerCheckoutShipment.propTypes = {
  shipment: PropTypes.shape({
    items                    : PropTypes.array,
    shipment_methods         : PropTypes.array,
    selected_shipment_method : PropTypes.object,
    is_insurance             : PropTypes.bool
  }),
  selectedOption               : PropTypes.string,
  handleClickShippingMethod    : PropTypes.func,
  handleClickInsuranceCheckbox : PropTypes.func,
  selectedShipmentMethod       : PropTypes.object
}

CustomerCheckoutShipment.defaultProps = {
  shipment: {
    items                    : [],
    shipment_methods         : [],
    selected_shipment_method : {}
  },
  selectedOption            : '',
  handleClickShippingMethod : () => { }
}

export default CustomerCheckoutShipment